module.exports = __webpack_public_path__ + "img/logo-light.5af44770.svg";